export function Brand({ compact = false }: { compact?: boolean }) {
  return (
    <span className={`brand-lockup${compact ? " brand-lockup--compact" : ""}`}>
      <img
        alt=""
        className="brand-lockup__mascot"
        src="/assets/assay-mascot.png"
      />
      <span className="brand-lockup__name">Assay</span>
    </span>
  );
}
